import {Component, ViewChild} from "@angular/core";
import {CalendarComponent} from "../userReservation/calendar/calendar";
import {IContext} from "../userReservation/userReservationEdit";
import {ModalTemplate, SuiModalService, TemplateModalConfig} from "ng2-semantic-ui";
import {ICurrentVan} from "../../../../../../domain/leasing/ICurrentVan";
import {IVanCalendar} from "../../../../../../domain/leasing/IVanCalendar";
import {CurrentVan} from "../../../../../../domain/leasing/CurrentVan";
import {Vans} from "../../../../../../../../../server/src/base/entities/leasing/Vans";
import {UnavailabilityVanCalendar} from "../../../../../../domain/leasing/UnavailabilityVanCalendar";
import {VanCalendar} from "../../../../../../domain/leasing/VanCalendar";
import {IUnavailabilityService} from "../../../../../../domain/leasing/IUnavailabilityService";
import {SlotsSelectionHandler} from "./SlotsSelectionHandler";
import {Slot} from "../../../../../../../../../server/src/base/entities/leasing/calendar/Slot";

@Component({
    selector: 'unavailability',
    styleUrls: ['./unavailability.scss'],
    templateUrl: './unavailability.html'
})
export class UnavailabilityComponent {
    @ViewChild('modalTemplate') modalTemplate:ModalTemplate<IContext, string, string>;
    @ViewChild(CalendarComponent) calendarComponent:CalendarComponent;

    private calendar:IVanCalendar;
    private unavailabilityService:IUnavailabilityService;
    private nbVans:number;
    private currentVan:ICurrentVan;
    private config:TemplateModalConfig<IContext, string, string>;
    private slotsSelectionHandler:SlotsSelectionHandler;

    constructor(unavailabilityService:IUnavailabilityService, public modalService:SuiModalService){
        this.unavailabilityService = unavailabilityService;
    }

    public Open(vans:Vans) {
        this.nbVans = vans.Value().length;
        this.currentVan = new CurrentVan(vans.Value());
        this.CreateCalendar();
        this.modalService.open(this.config);

        var that = this;
        setTimeout(() => {
            that.UpdateCalendar();
        }, 500);
    }

    public ngOnInit(){
        this.config = new TemplateModalConfig<IContext, string, string>(this.modalTemplate);
        this.config.closeResult = "closed!";
        this.config.isClosable = false;
        this.config.context = { data: "" };
    }

    public onSlotSelected(slot:Slot){
        this.slotsSelectionHandler.SelectSlot(slot);
    }

    public onSlotUnSelected(slot:Slot){
        this.slotsSelectionHandler.UnselectSlot(slot);
    }

    public update(modal){
        this.slotsSelectionHandler.Handle().then(() => {
            this.cancel(modal);
        })
    }

    public nextVan(){
        if(this.currentVan.Next()){
            this.UpdateCalendar();
        }
    }

    public previousVan(){
        if(this.currentVan.Previous()){
            this.UpdateCalendar();
        }
    }

    protected UpdateCalendar(){
        this.calendar.Update(this.currentVan.Value());
        this.calendarComponent.Reset(this.currentVan.Value().unavailability.Slots());
        this.slotsSelectionHandler = new SlotsSelectionHandler(this.unavailabilityService, this.currentVan.Value().unavailability);
    }

    public cancel(modal){
        modal.deny('denied');
    }

    private CreateCalendar(){
        let vanCalendar:IVanCalendar = new VanCalendar(this.currentVan.Value());
        this.calendar = new UnavailabilityVanCalendar(vanCalendar, this.currentVan, true);
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/unavailability/unavailability.ts